import { ArrowRight } from "lucide-react";
import React from "react";
import { Button } from "src/components/ui/button";
import ProductLogo from "src/components/ui/icons/ProductLogo";
import { isRootlyBranded } from "src/utils/brandTheme";

interface WelcomeStepProps {
  onGetStarted: () => void;
  brandTheme?: string | null;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onGetStarted, brandTheme }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-8 py-12">
      <div className="max-w-4xl text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex flex-col items-end">
            <ProductLogo brandTheme={brandTheme} tierzeroClassName="h-14 w-auto" showPoweredBy poweredByClassName="text-[11px] uppercase text-muted-foreground font-semibold mt-1" />
          </div>
        </div>

        {/* Headline */}
        {isRootlyBranded(brandTheme) ? (
          <>
            <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Where AI SRE agents and your teams
              <br />
              resolve incidents together.
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
              Rootly AI SRE analyzes your code changes, telemetry, and past incidents—to quickly identify root causes
              and the fix—even if you don&apos;t know that code.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-3xl md:text-4xl text-foreground mb-6">
              <span className="font-semibold">AI already transformed how you write code.</span>
              <br />
              <span className="italic text-muted-foreground">Now transform how you run it.</span>
            </h1>
            <p className="text-sm text-muted-foreground mb-10 tracking-wide uppercase">
              Resolve incidents faster&nbsp;&nbsp;·&nbsp;&nbsp;Production context anywhere&nbsp;&nbsp;·&nbsp;&nbsp;Catch problems earlier
            </p>
          </>
        )}

        {/* CTA */}
        <Button size="lg" onClick={onGetStarted} className="text-lg px-10 py-7">
          Get Started
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>

        <p className="text-muted-foreground mt-6">Takes about 5 minutes to set up</p>
      </div>
    </div>
  );
};
